import React from 'react';

type Props = {
  children: React.ReactNode;
  /** Tailwind gap utility (e.g. "gap-1", "gap-0.5"). Default `gap-0.5`. */
  gap?: string;
  className?: string;
};

/**
 * Flex column wrapper used to stack a label above an input. Mirrors
 * `primitiveStyles.fieldStacked` from the prototype.
 */
const Stack: React.FC<Props> = ({ children, gap = 'gap-0.5', className }) => (
  <div className={`flex flex-col ${gap} py-[0.1875rem] ${className ?? ''}`}>
    {children}
  </div>
);

export default Stack;
